/** Query params that may carry one-time auth secrets — scrubbed before logging. */
export const SENSITIVE_QUERY_KEYS = ['token', 'reset_token', 'invite_token', 'auth_token']

/** Drop sensitive query params (auth tokens) from a URL before it reaches logs/Sentry. */
export function sanitizeLoggedUrl(raw: string): string {
  try {
    const u = new URL(raw, 'http://placeholder.local')
    let changed = false
    for (const key of SENSITIVE_QUERY_KEYS) {
      if (u.searchParams.has(key)) {
        u.searchParams.delete(key)
        changed = true
      }
    }
    if (!changed) {
      return raw
    }
    const next = u.pathname + u.search + u.hash
    return u.origin === 'http://placeholder.local' ? next : new URL(next, u.origin).href
  } catch {
    return raw
  }
}
